import React from 'react'
import Header from '../Components/Header'
import Contact from '../Components/Contact'
import Footer from '../Components/Footer'

const ContactUs = () => {
  return (
    <>
    <Header />
    <Contact />
    <Footer />
    </>
  )
}

export default ContactUs